module.exports = __webpack_public_path__ + "static/prevents-8536eeb2ba2d019c80b47e87aece3c9f.svg";